import React from 'react'
import Constants from 'EurestoFonction/Constants'
import DataComponent from '../../../DataComponents/index'
import Grid from '@material-ui/core/Grid'
import moment from 'moment'
import ApiRequest from 'EurestoApi/ApiRequest'
import EurestoForm from 'Components/Form'
import Utils from 'EurestoFonction/Utils'
import Input from "Components/Input";
import DatePicker from "Components/DatePicker";
import Data from "EurestoClass/Data";


const project = require('EurestoConfig/project.config')

moment.locale('fr')
export default class extends React.Component {
  constructor (props) {
    super(props)

    const annee = props.annee

    const newState = {
      ...props,
      annee: annee ? [moment(annee+'-01-01').format('YYYY-MM-DD'),moment(annee+'-12-31').format('YYYY-MM-DD')] : [moment().format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')],
      action: props.action,
      key: Utils.getRandomNumber(),
    }
    this.state = {
      saveState: { ...EurestoClone(newState)},
      ...newState
    }
  }

  componentDidMount () {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getClasse()
    }
  }

  getClasse = async () => {
    const result = await ApiRequest(project.api + 'pedagogie', {
      requete: 'classe',
      action: 'get',
      id: this.state.id
    }, { showAlertError: false })
    if(result && result.code === 1) {
      const newState = {
        defaultLibelle: result.results.libelle,
        libelle: result.results.libelle,
        abrege: result.results.abrege,
        classe_id: result.results.classe_id,
        formation_id: result.results.formation_id,
        actif: result.results.actif,
        annee: [moment(result.results.annee+'-01-01').format('YYYY-MM-DD'), moment(result.results.annee+'-12-31').format('YYYY-MM-DD')],
        key: Utils.getRandomNumber()
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangeState = (e, name) => {
    this.setState({
      [name]: e
    }, this.forceUpdate)
  }

  onCancel = _ => {
    this.setState({
      libelle: undefined,
      abrege: undefined,
      classe_id: undefined,
      formation_id: undefined,
      action: 'add',
      actif: 1,
      annee: [moment().format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')],
      key: Utils.getRandomNumber()
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {
    const result = await ApiRequest(project.api + 'pedagogie', {
      requete: 'classe',
      action: action === 'update' ? 'update' : 'add',
      id: this.state.id,
      libelle: this.state.libelle,
      abrege: this.state.abrege,
      classe_id: this.state.classe_id,
      formation_id: this.state.formation_id,
      annee: moment(this.state.annee[0]).format('YYYY'),
      actif: this.state.actif,
    })
    if (result.code === 1) {
      this.onCancel()
    }
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'pedagogie', {
      requete: 'classe',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = {...EurestoClone(this.state.saveState)}
      newState.key = Utils.getRandomNumber();
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  form = (disabled, autoFocus) => {
    return (
      <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
            justify="flex-start"
            alignItems="stretch">
        <Input
            key={autoFocus}
            autoFocus={autoFocus}
            title={EurestoI18n.t('commun:Nom')}
            onChange={this.onChangeState}
            name={'libelle'}
            disabled={disabled}
            value={this.state.libelle}
        />
        <Input
            title={EurestoI18n.t('commun:Abrégé')}
            onChange={this.onChangeState}
            name={'abrege'}
            disabled={disabled}
            value={this.state.abrege}
        />
        {!this.state.sub && <React.Fragment>
          <DataComponent
          title={EurestoI18n.t('commun:Formation')}
          name="formation_id"
          disabled={disabled}
          type={Constants.typeSaisie.ComboSimple}
          onChange={this.onChangeState}
          data={this.state.formation_id}
          object={Constants.donnee.formation}
          module={Constants.module.PEDAGOGIE}/>
        <DatePicker
            year
            scolaire
            title={EurestoI18n.t('commun:Année Scolaire')}
            onChange={this.onChangeState}
            name={'annee'}
            disabled={disabled}
            value={this.state.annee}
        />
        </React.Fragment>}
        {this.state.sub && <DataComponent
          title={EurestoI18n.t('commun:Classe')}
          name="classe_id"
          disabled={disabled}
          type={Constants.typeSaisie.ComboSimple}
          onChange={this.onChangeState}
          data={this.state.classe_id}
          object={Constants.donnee.classe}
          module={Constants.module.PEDAGOGIE}
          search={{ classe_id: null }}/>}
      </Grid>
    )
  }

  render () {
    return (
      <EurestoForm key={this.state.key}
                   {...this.props.formProps}
                   libelle={this.state.defaultLibelle}
                   action={this.state.action}
                   isAllow={this.props.isAllow}
                   onSave={this.onSave}
                   onCancel={this.onCancel}
                   onDelete={this.onDelete}
                   onArchive={this.onArchive}
                   onView={this.onView}
                   libelleAdd={!this.props.sub && EurestoI18n.t('commun:Nouvelle classe') || (EurestoI18n.t('commun:Nouveau groupe de la classe') + ' [' + (this.state.classe_id && Data.get(Constants.module.PEDAGOGIE, Constants.donnee.classe, { id: this.state.classe_id }) && Data.get(Constants.module.PEDAGOGIE, Constants.donnee.classe, { id: this.state.classe_id }).libelle || '') + ']')}
                   children={this.form}/>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Pedagogie/Classe.js